<template>
  <card>
     <template slot="header">
        <h4 class="card-title">Coaching Details</h4>
     </template>
     <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
           <li class="breadcrumb-item">
              <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
           </li>
           <li class="breadcrumb-item">
              <router-link to="/hr/coaching/records">Employee Coached</router-link>
           </li>
           <li class="breadcrumb-item active">Coaching Details</li>
        </ol>
     </nav>
     <hr style="margin-top:-10px" />
     <div class="report-container" id="printme">    
            <img class="logo-print" width="190" height="110" src="/static/img/blueprintlogo.png" alt="..."/><br/><br/>
            <span class="float-right"><img width="30" height="30" id="printIcon" onclick="window.print()" src="/static/img/print.png" alt="..." /></span><br/><br/>
        <div class="col-md-12 report-border-full">
           <span class="report-header">EMPLOYEE COACHING FORM</span>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
           <div class="row">
              <div class="col-md-6 report-border-right">
                 <b>Employee Name :</b> {{item.full_name}}
                 <br/>
                 <b>Position : </b> {{item.position_name | capitalize}}
                 <br/>
                 <b>Department : </b> {{item.department_name | capitalize}}
                 <br/>
                 <b>Employment Status : {{item.status | capitalize}}</b>
              </div>
              <div class="col-md-6">
                 <b>Employee Number : </b> {{item.emp_id}}
                 <br/>
                 <b>Immediate Supervisor :</b>  {{item.superior_name}}
                 <br/>
                 <b>Department Manager : </b> Nile Dano
                 <br/>
                 <b>Hired Date: {{getDate(item.employment_date)}} </b>   
              </div>
           </div>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
           <div class="row">
              <div class="col-md-4 report-border-right">
                 <h4><b>Agreement</b></h4>
                 (Employee agreed that these items should be duscussed during the coaching session)
                 <br/> <br/>
              </div>
              <div class="col-md-8">
                 <br>
                 <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.agreement}}</pre>
              </div>
           </div>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
           <div class="row">
              <div class="col-md-4 report-border-right">
                 <h4><b>Strengths</b></h4>
                 (Employee agreed that these items should be discussed during the coaching session)
                 <br/> <br/>
              </div>
              <div class="col-md-8">
                 <br>
                 <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.strength}}</pre>
              </div>
           </div>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
           <div class="row">
              <div class="col-md-4 report-border-right">
                 <h4><b>Performance</b></h4>
                 (Employee agreed that these items should be duscussed during the coaching session)
                 <br/> <br/>
              </div>
              <div class="col-md-8">
                 <br>
                 <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;"> {{item.performance}}</pre>
              </div>
           </div>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
           <div class="row">
              <div class="col-md-4 report-border-right">
                 <h4><b>Impact of the Performance</b></h4>
                 (Impact of the performance towards the clients, employee, team and company)
                 <br/> <br/>
              </div>
              <div class="col-md-8 pb-4 pt-3">
                <b>Clients:</b>  
                <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.client}}</pre><br/>
                <b>Employee:</b>
                <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.employee}}</pre><br/>
                <b>Team:</b>
                <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.team}}</pre><br/>
                <b>Company:</b>
                <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.company}}</pre>
             </div>
           </div>
        </div>
        <div class="report-gatter"></div>
        <div class="col-md-12 report-border-full">
           <div class="row">
              <div class="col-md-4 report-border-right">
                 <h4><b>Action Plans</b></h4>
                 (Employee agreed that these items should be duscussed during the coaching session)
                 <br/> <br/>
              </div>
              <div class="col-md-8 pb-4 pt-3">
                 <label>What is your action plan :</label><br/>
                 <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.employee_commitment}}</pre>
              </div>
           </div>
        </div>
            <div class="gatterBreak"></div>
            <div class="report-gatter"></div>
            <div class="col-md-12 report-border-full">
              <div class="row">
                  <div class="col-md-4 report-border-right">
                    <h4><b>Expected Results</b></h4>
                    (What are the expected results after the actions plan are implemented ? Include timeline)
                    <br/> <br/>
                  </div>
                  <div class="col-md-8 pb-4 pt-3">
                    <label>What is your expected result :</label> <br/>
                    <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.expected_result}}</pre>
                  </div>
              </div>
            </div>
            <br/> <br/>
          
            <p>  I hereby acknowledge that I have been coached according to standard set by the company and commit to the objectives and targets stated above. </p>
            <br/><br/> 
            <!-- SIGNATURE-SECTION -->    
            <div class="row">
              <div class="col-md-8 pb-4 pt-3">
              </div>
              <div class="col-md-4">
                <br/><br/>
                <span v-if="item.employee_status == 'acknowledged'">
                <div  class="report-signature-container">
                   <img class="report-signature-control"  :src="item.employee_signature" alt="..."/>
                </div>
                <div class="report-printed-control-coaching"><b><center>{{item.first_name | uppercase}} {{item.last_name | uppercase}}</center></b></div>
                <div class="report-line-divider"></div>
                <center>Signature over Printed Name</center>
               </span>
                <span v-else>
                  <center><p style="color:red">Unacknowledged.</p></center>
                </span> 
               
             </div>
            </div>
            <!--END SIGNATURE SECTION -->
            <br/><br/>
            <p>HR FORM NO. 0004</p>
            
     </div>
  </card>
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card,
  },
  data() {
    return {
      item: {}
    }
  },
  created: function () {
    this.getItem()
  },
  methods: {
    printPreview(){
          
          var newstr = document.getElementById('printme').innerHTML;
          document.body.innerHTML = newstr
          var oldstr = document.body.innerHTML
          window.close()
          window.print()
         
          document.body.innerHTML = oldstr
          window.location.reload()
    },
    getItem() {
      axios.get('api/employee/coaching/get/' + this.$route.params.id)
      .then(resp => {
        this.item = resp.data;
        console.log(JSON.stringify(resp.data));
      });
    },
  },
}
</script>
 <style media="all">
  #printIcon{
      cursor: pointer;
    }


   @media print {    
     #printIcon  {
       display: none;
     }
  
    body * { 
     visibility: hidden; 
     position: static;    
     overflow: unset!important;        
    } 
     
     .gatterBreak{
       height: 300px;
     }
     .report-container{
       position: fixed;
       top:0;
       width: auto;
     }

     .report-header{
      margin: auto 30% !important;
      font-size: 25px;
     }

     #printme, #printme * { 
      visibility: visible; 
    }

    
  }

</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-employee-coached-details.vue